<div class="d-flex" style="position: relative;">
  <div class="card-body row m-0" style="padding: 24px">
    <div class="input-group form-password-toggle d-flex" style="width: 300px;">
      <input
        type="text"
        class="form-control"
        placeholder="Recherche par mot clé"
        aria-label="Search..."
        aria-describedby="basic-addon-search-reassort"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearch()"
      />
      <div class="input-group-append" style="margin-right: 10px;">
        <span class="input-group-text" id="basic-addon-search-reassort" style="color: black;">
          <i data-feather="search" [size]="20"></i>
        </span>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-outline-primary btn-icon"
      (click)="toggleFilter()"
      style="padding: 10px 11px !important;"
      rippleEffect
    >
      <span data-feather="filter"></span>
    </button>

    <div
      class="active-filters-container d-flex flex-wrap align-items-center gap-2"
      style="margin-left: 12px;"
      *ngIf="getActiveFilters().length > 0"
    >
      <div
        *ngFor="let filter of getActiveFilters(); trackBy: trackByFilterKey"
        class="filter-badge"
      >
        <span class="filter-badge-label">{{ filter.label }}:</span>
        <span class="filter-badge-value">{{ filter.value }}</span>
        <button
          type="button"
          class="filter-badge-close"
          (click)="removeFilter(filter.key, $event)"
          aria-label="Supprimer le filtre"
        >
          <i data-feather="x" style="width: 12px; height: 12px;"></i>
        </button>
      </div>
    </div>
  </div>

  <div
    class="card filter-sidebar length"
    *ngIf="showFilter"
    style="width: 380px; max-height: 320px; box-shadow: 0 4px 18px rgba(47, 43, 61, 0.16);"
  >
    <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
      <h4 class="card-title mb-0">Filtres</h4>
      <button
        type="button"
        class="btn btn-sm btn-icon btn-light"
        (click)="toggleFilter()"
        aria-label="Fermer"
      >
        X
      </button>
    </div>
    <div class="card-body d-flex flex-column p-1">
      <div class="flex-grow-1 overflow-auto pe-1">
        <div class="mb-1 filter-date-container">
          <div class="d-flex w-100" style="gap: 12px;">
            <div class="flex-grow-1">
              <label for="reassortDateDu" class="form-label">Date de création</label>
              <input
                id="reassortDateDu"
                type="date"
                class="form-control m-0"
                [(ngModel)]="draftDateDebut"
              />
            </div>
            <div class="flex-grow-1">
              <label for="reassortDateJusqua" class="form-label">Jusqu'à</label>
              <input
                id="reassortDateJusqua"
                type="date"
                class="form-control m-0"
                [(ngModel)]="draftDateFin"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="pt-2 d-flex justify-content-end gap-1">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="resetFilters()"
          style="margin-right: 15px;"
        >
          Réinitialiser
        </button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
      </div>
    </div>
  </div>
</div>

<div class="table-full-width">
  <div class="table-responsive" style="height: 640px">
    <table class="table table-hover">
      <thead class="custom-header">
        <tr>
          <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 18%">RÉFÉRENCE</th>
          <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">DATE</th>
          <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 18%">Entrepôt initial</th>
          <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 18%">Entrepôt destination</th>
          <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 10%">QUANTITÉ</th>
          <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">STATUT</th>
          <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 200px">ACTION</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="7" class="p-0 border-0">
            <div class="erp-table-skeleton">
              <div class="erp-table-skeleton__row" *ngFor="let _ of skeletonRows">
                <span class="erp-table-skeleton__cell erp-table-skeleton__cell--ref"></span>
                <span class="erp-table-skeleton__cell"></span>
                <span class="erp-table-skeleton__cell"></span>
                <span class="erp-table-skeleton__cell erp-table-skeleton__cell--short"></span>
                <span class="erp-table-skeleton__cell erp-table-skeleton__cell--badge"></span>
                <span class="erp-table-skeleton__cell erp-table-skeleton__cell--actions"></span>
              </div>
            </div>
          </td>
        </tr>
        <ng-container *ngIf="!loading">
          <tr *ngFor="let row of rows">
            <td>
              <a class="ref cursor-pointer" (click)="openDetail(row, $event)">
                {{ cell(row, 'N° DOCUMENT') }}
              </a>
            </td>
            <td>{{ cell(row, 'DATE TRANSFERT') }}</td>
            <td>{{ cell(row, 'DÉPART') }}</td>
            <td>{{ cell(row, 'RÉCEPTION') }}</td>
            <td>{{ cell(row, 'QUANTITÉ') }}</td>
            <td>
              <div class="status-badge-wrapper">
                <span class="badge" [ngClass]="statusBadgeClass(row)">{{ cell(row, 'STATUT') }}</span>
              </div>
            </td>
            <td class="action-icons d-flex align-items-center">
              <a
                class="me-2 action-icon"
                title="Modifier le document"
                (click)="openDetail(row, $event)"
                style="color: rgba(47, 43, 61, 0.7); margin-right: 30px; width: 20px; height: auto"
              >
                <span data-feather="edit" [size]="20" [inner]="true"></span>
              </a>
              <a
                class="me-2 action-icon"
                title="Aperçu du document"
                (click)="openDetail(row, $event)"
                style="color: rgba(47, 43, 61, 0.7); margin-right: 30px; width: 20px; height: auto"
              >
                <span data-feather="eye" [size]="20" [inner]="true"></span>
              </a>
              <a
                class="me-2 action-icon"
                [class.disabled]="!canArchiver(row)"
                [style.pointer-events]="canArchiver(row) ? 'auto' : 'none'"
                [style.opacity]="canArchiver(row) ? '1' : '0.45'"
                [style.cursor]="canArchiver(row) ? 'pointer' : 'not-allowed'"
                [title]="canArchiver(row) ? 'Archiver (non approuvé)' : 'Archivage disponible uniquement si le réassort n’est pas encore approuvé'"
                (click)="canArchiver(row) && archiver(row, $event)"
                style="color: rgba(234, 84, 85, 0.85); margin-right: 12px; width: 20px; height: auto"
              >
                <span data-feather="archive" [size]="20" [inner]="true"></span>
              </a>
            </td>
          </tr>
          <tr *ngIf="rows.length === 0">
            <td colspan="7" class="text-center text-muted py-2">Pas de données à afficher</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<app-table-pagination-bar
  [totalItems]="serverTotal"
  [pageFrom]="pageFrom"
  [pageTo]="pageTo"
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  [pageSize]="pageSize"
  itemsLabel="réassort(s)"
  nameSuffix="reassort"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
></app-table-pagination-bar>
